{
  "title": "Nathair's Mischief (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "2nd-level illusion",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S, M (a piece of crust from an apple pie)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You fill a 20-foot cube centered on a point you choose within range with fey and draconic magic. Roll on the Mischievous Surge table to determine the magical effect produced. At the start of each of your turns, you can move the cube up to 10 feet and reroll on the table.",
    "Mischievous Surge",
    "d4",
    "Effect",
    "1",
    "The smell of apple pie fills the air, and each creature in the cube must succeed on a Wisdom saving throw or become charmed by you until the start of your next turn.",
    "2",
    "Bouquets of flowers appear all around, and each creature in the cube must succeed on a Dexterity saving throw or be blinded until the start of your next turn as the flowers spray water in their faces.",
    "3",
    "Each creature in the cube must succeed on a Wisdom saving throw or begin giggling until the start of your next turn. A giggling creature is incapacitated and uses all its movement to move in a random direction.",
    "4",
    "Drops of molasses appear and hover in the cube, turning it into difficult terrain until the start of your next turn."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
